<div class="success-container">
  <div class="success-content">
    <div class="success-icon">
      <mat-icon>check_circle</mat-icon>
    </div>
    
    <h2>Payment Successful!</h2>
    <p>Thank you for your purchase. Your subscription is now active and ready to use.</p>
    
    <div class="transaction-message">
      <p>Your transaction has been processed successfully. You can view the details of your subscription in the billing section.</p>
    </div>
    
    <div class="action-buttons">
      <button mat-raised-button color="primary" (click)="goToBilling()">
        View Subscription Details
      </button>
      
      <button mat-stroked-button (click)="goToDashboard()">
        Go to Dashboard
      </button>
    </div>
  </div>
</div>